export const RegexConstants = {
    // This regex checks if the document id is only numbers
    IS_DIGITS_ONLY: /^\d+$/,
    VALID_YOUTUBE_URL: /(?:youtube\.com\/(?:[^/]+\/.+\/|(?:v|e(?:mbed)?)\/|.*[?&]v=)|youtu\.be\/)([^"&?/ ]{11})/i,
    PROSEMIRROR_SCHEMA_BOLD_REGEX: /^(bold(er)?|[5-9]\d{2,})$/,
    PROSEMIRROR_FIND_ESCAPED_SQUARE_BRACKET: /[`*\\~[\]]/g,
    PROSEMIRROR_FIND_EQUALS: /=/g,
    // Naming might not be correct
    PROSEMIRROR_FIND_ANCHOR_REFERENCES: /^[:#\-*+]/,
    // Naming might not be correct
    PROSEMIRROR_FIND_DIGITS: /^(\d+)\./,
    // Naming might not be correct
    PROSEMIRROR_ESCAPED_REPLACE: "\\$&"

} as const;